import { FunctionalComponent, h } from 'preact';

import { IconTemplatePropsInterface } from 'common/module/icon/template-props.interface';

export const IconTrashTemplate: FunctionalComponent<IconTemplatePropsInterface> = (props) => (
  <svg viewBox='0 0 10 12' width='10' height='12' className={props.class}>
    <use xlinkHref='#svg-trash' />
  </svg>
);
